import { QueryDatabaseResponse } from '@notionhq/client/build/src/api-endpoints';
import { useSearchParams } from 'remix';
import invariant from 'tiny-invariant';

type TagProps = {
  id?: QueryDatabaseResponse['results'][number]['id'];
  color?: QueryDatabaseResponse['results'][number]['properties'];
} & QueryDatabaseResponse['results'][number]['properties'];

export const Tag = ({ color, id, shortLabel, value }: TagProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  invariant(shortLabel?.type === 'rich_text', 'missing shortlabel');
  invariant(value?.type === 'rich_text', 'missing value for tag');
  invariant(color?.tailwindRef?.type === 'rich_text', 'tailwindRef missing');
  invariant(id, 'no id');

  const toggleTag = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();

    let searchTags = searchParams.getAll('tags');

    if (searchTags.length && searchTags.find((el) => el === id))
      searchTags = searchTags.filter((el) => el !== id);
    else searchTags = [...searchTags, id];

    searchParams.delete('tags');
    searchTags.forEach((newTag) => {
      searchParams.append('tags', newTag);
    });
    setSearchParams(searchParams);
  };

  const twColor = `bg-${color?.tailwindRef?.rich_text[0]?.plain_text}`;

  return (
    <div
      key={id}
      onClick={toggleTag}
      className={`text-xs rounded-full ${twColor} px-4 py-1 max-w-max overflow-hidden truncate hover:bg-opacity-60 cursor-pointer`}
    >
      {shortLabel?.rich_text[0]?.plain_text}
    </div>
  );
};
